import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static values = {
        datepickerLanguage: String,
        datepickerEndDate: String,
        pricingDate: String,
        siteAccess: String,
        priceType: String
    }

    connect() {
        this.#initDatePicker();
    }

    showDatepicker() {
        $(this.element).find('.date-picker-wrapper')
            .attr('data-state', 'show')
            .find('input')
            .removeAttr('disabled');
    }

    hideDatepicker() {
        $(this.element).find('.date-picker-wrapper')
            .attr('data-state', 'hide')
            .find('input')
            .attr('disabled', 'disabled');
    }

    getMetalInfoPrices() {
        const $element = $(this.element);
        const pickedDate = this.#getPickedDateTo();
        const selectedPriceType = this.#getSelectedPriceType();
        $element.addClass('loading');
        const formatted = this.formatDateToYYYYMMDD(pickedDate);
        $.ajax({
            method: 'GET',
            url: `/${this.siteAccessValue}/ajax/metalinfo-daily-prices/${formatted}/${selectedPriceType}`,
        })
        .done((response) => {
            $('.list-wrapper.daily-prices-house-technology').replaceWith(response.content.template);
        })
        .fail((jqXHR, textStatus, errorThrown) => {
            $element.find('.datepicker-to').val(this.pricingDateValue);
            $element.find(`input[name="price-line"][data-price-type="${this.priceTypeValue}"]`).prop('checked', true);
        })
        .always(() => {
            $element.removeClass('loading');
        })
    }

    #getPickedDateTo() {
        const $pickerTo = $(this.element).find('.datepicker-to');
        const pickedDate = $pickerTo.datepicker('getDate');
        return pickedDate;
    }

    #getSelectedPriceType() {
        const $selectedPriceType = $(this.element).find('input[name="price-line"]:checked');
        return $selectedPriceType.data('price-type');
    }

    #initDatePicker() {
        const $element = $(this.element);
        const $pickerTo = $element.find('.datepicker-to');
        const $triggerTo = $pickerTo.next();
        const $endDate= this.datepickerLanguageValue==='de-DE'? this.datepickerEndDateValue: new Date(this.datepickerEndDateValue);
        const datepickerConfig = {
            language: this.datepickerLanguageValue,
            endDate: $endDate,
        };

        $pickerTo.datepicker($.extend({}, datepickerConfig, {
            autoHide: true,
            trigger: $triggerTo
        }));

        $pickerTo
            .off('pick.datepicker')
            .on('pick.datepicker', () => {
                $pickerTo[0].dispatchEvent(new Event('change', { bubbles: true }));
            });
    }

    formatDateToYYYYMMDD(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}${month}${day}`;
    }
}
